









































































































































import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import UserGoal from '../../../api/v2/models/user_goal'
import api from '../../../api/v2/api'
import {format, getDay} from 'date-fns'
import {headerState} from '../../stores/header'
import GoalMilestoneWeb from '../atoms_molecules/GoalMilestoneWeb.vue'
import GoalMilestoneMobile from '../atoms_molecules/GoalMilestoneMobile.vue'
import UserGoalSuggestion from '../atoms_molecules/UserGoalSuggestion.vue'
import UserGoalAi from '../atoms_molecules/UserGoalAi.vue'
import GoalSummary from '../atoms_molecules/GoalSummary.vue'
import MesageContainer from '../organisms/MesageContainer.vue'
import {checkMobile} from '../../utils/utils'
import {ROUTER_NAME} from '../../router'
import ThreadContainer from "../organisms/ThreadContainer.vue";
import {Multipane, MultipaneResizer} from 'vue-multipane'

@Component({
  components: {
    ThreadContainer,
    GoalMilestoneWeb,
    GoalSummary,
    GoalMilestoneMobile,
    UserGoalSuggestion,
    UserGoalAi,
    MesageContainer,
    Multipane,
    MultipaneResizer,
  }
})
export default class UserGoalDetail extends Vue {
  userGoal: UserGoal | null = null
  tab: number | null = null
  tabSelected = null

  mobile = checkMobile()

  get breadcrumbs() {
    return [
      {
        text: 'ゴール一覧',
        disabled: false,
        exact: true,
        to: '/classroom/user-goals/'
      },
      {
        text: this.userGoal ? this.userGoal.goal.name : '',
        disabled: true
      }
    ]
  }

  async created() {
    this.userGoal = await api.userGoal.show(this.$route.params.userGoalId)
    headerState.setTitle(this.userGoal.goal.name)
    api.userGoal.saveActivity(this.$route.params.userGoalId)
  }

  get schoolSetting() {
    return headerState.schoolSetting
  }

  dateFormat(date: string, formatDate: string = 'MM/DD') {
    return format(date, formatDate)
  }

  dateOfWeek(date: string) {
    const japanDays = {
      0: '日曜',
      1: '月曜',
      2: '火曜',
      3: '水曜',
      4: '木曜',
      5: '金曜',
      6: '土曜'
    }
    return japanDays[getDay(date) || 0]
  }

  toCourse(id: string) {
    this.$router.push({
      name: ROUTER_NAME.MY_COURSE_DETAIL,
      params: {
        courseId: id
      },
    })
  }

  toExam(id: string) {
    this.$router.push({
      name: ROUTER_NAME.EXAM_DETAIL,
      params: {
        examId: id
      },
    })
  }

  updateParentTab(value: number) {
    this.tab = value
  }

  emitCreateThread(value: number) {
    if (typeof value === 'number') {
      this.tab = value;
    }
    (this.$refs.mesageContainer as any).createThread()
  }
}
